module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.display) ? _c('div', {
    directives: [{
      name: "modal-show",
      rawName: "v-modal-show",
      value: (_vm.display),
      expression: "display"
    }],
    attrs: {
      "id": "identityClass"
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('section', {
    staticClass: "M_wrap M_certification M_btn_1 M_top",
    staticStyle: {
      "top": "270px",
      "display": "block"
    }
  }, [_c('p', {
    staticClass: "M_title T_18_25 T_b"
  }, [_vm._v("实名认证")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "M_form"
  }, [_c('div', {
    staticClass: "M_f_item"
  }, [_c('label', {
    staticClass: "T_14_24",
    attrs: {
      "for": ""
    }
  }, [_vm._v("真实姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "M_f_item"
  }, [_c('label', {
    staticClass: "T_14_24",
    attrs: {
      "for": ""
    }
  }, [_vm._v("身份证号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.cardId),
      expression: "cardId",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号码"
    },
    domProps: {
      "value": (_vm.cardId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardId = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "M_f_btns cf"
  }, [_c('a', {
    staticClass: "M_btn T_w M_b_close",
    attrs: {
      "href": "javascript:void(0);",
      "title": "提交认证"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("提交认证")])]), _vm._v(" "), _c('div', {
    staticClass: "M_f_coupon"
  }, [_c('p', {
    staticClass: "M_f_c_amount T_12_16"
  }, [_c('em', [_vm._v("￥"), _c('i', [_vm._v(_vm._s(_vm.syMoney))])]), _vm._v(" "), _c('span', [_vm._v("满￥" + _vm._s(_vm.syOrder) + "使用")])]), _vm._v(" "), _c('p', {
    staticClass: "M_f_c_tip T_12_16"
  }, [_vm._v("实名认证通过送" + _vm._s(_vm.syMoney) + "元代金券")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "M_close I_n",
    on: {
      "click": _vm.close
    }
  })])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "M_cont"
  }, [_c('p', {
    staticClass: "T_12_18 T_w"
  }, [_vm._v("根据国家规定，必须进行实名认证，才可体验游戏服务，为帮助未成年人防沉迷，请填写身份信息认证。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "M_cont"
  }, [_c('p', {
    staticClass: "T_12_14 T_w"
  }, [_vm._v("1、身份信息仅用于实名认证使用，本平台承诺绝不向任何第三方透露。")]), _vm._v(" "), _c('p', {
    staticClass: "T_12_14 T_w"
  }, [_vm._v("2、具体以游戏内活动为准。")]), _vm._v(" "), _c('p', {
    staticClass: "T_12_14 T_w"
  }, [_vm._v("3、如有任何疑问，请咨询阅文客服QQ：800038605")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9989d9ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/v2/components/common/IdentityConfirmModal.vue
// module id = 523
// module chunks = 142